import React, { useState } from "react";
import { FaPlus, FaMinus, FaChevronLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import rawMenuData from "./MenuData";
import { useHiddenCategories, filterMenu } from "../../api/hiddenCategories";
import SearchBar from "./SearchBar";
import "./Header.css";
const MobileMenu = ({ isOpen, setIsOpen }) => {
  const hiddenCategories = useHiddenCategories();
  const menuData = filterMenu(rawMenuData, hiddenCategories);
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`mobile-overlay ${isOpen ? "show" : ""}`}
        onClick={() => setIsOpen(false)}
      ></div>

      {/* Sidebar */}
      <div className={`mobile-sidebar ${isOpen ? "active" : ""}`}>
        <div className="mobile-header">
          <button onClick={() => setIsOpen(false)}>
            <FaChevronLeft />
          </button>

          <h3>Our Astro Shop</h3>
        </div>

        {/* SEARCH (the header's own box is hidden on small screens) */}
        <SearchBar
          className="mobile-search"
          onNavigate={() => setIsOpen(false)}
        />

        <div className="mobile-links">
          {menuData.map((menu, index) => (
            <div key={index}>
              {!menu.megaMenu ? (
                <Link
                  to={menu.link}
                  className="mobile-link"
                  onClick={() => setIsOpen(false)}
                >
                  {menu.title}
                </Link>
              ) : (
                <>
                  <div
                    className="mobile-link accordion-title"
                    onClick={() => toggleAccordion(index)}
                  >
                    <span>{menu.title}</span>

                    {openIndex === index ? <FaMinus /> : <FaPlus />}
                  </div>

                  <div
                    className={`accordion-content ${
                      openIndex === index ? "open" : ""
                    }`}
                  >
                    {menu.categories.map((cat, i) => (
                      <div className="mobile-category" key={i}>
                        <Link
                          to={cat.link || `/shop/${cat.slug}`}
                          className="mobile-category-header"
                          onClick={() => setIsOpen(false)}
                          style={{ textDecoration: "none", color: "inherit", display: "block" }}
                        >
                          <h4>{cat.title}</h4>
                        </Link>

                        {cat.items.map((item, idx) => (
                          <Link
                            key={idx}
                            to={item.link || `/shop/${cat.slug}/${item.slug}`}
                            className="mobile-sub-link"
                            onClick={() => setIsOpen(false)}
                          >
                            {item.title}
                          </Link>
                        ))}
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
